import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';
// import Spinner from "COMPONENTS/Spinner/Spinner";
import HeaderContainer from "../Header/HeaderContainer";
import EditOrganization from "./EditOrganization";

//Daterangepicker
import 'react-dates/initialize';

//Constant
import {CONFIG, TIMEOUT, ERROR } from "../../../Utils/Constants";
//Strings
import { getMessage } from "CONFIG/i18n";
//Actions
import { organisationAction } from "CONFIG/ActionFactory";
import Spinner from "COMPONENTS/Spinner/Spinner";

import { getWording, getTranslation } from "../../../Redux/Selector/OrganisationSelector";
class EditOrganizationContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      storageChanged: false,
      currentBucket: "",
      focused : null,
      spinnerVisibilityMain : false,
    };
  }
  componentDidMount() {
    if(!this.props.editOrganisationData)
    {
      this.props.history.push(CONFIG.path.superAdmin)        
    }    
  }
  handleCancelClick = () => {
    this.props.history.goBack();
  };

  getCurrentDate = () => {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = today.getFullYear();

    today = yyyy + "-" + mm + "-" + dd;
    return today;
  };

  verifyStorage=(storageElement,callback)=>{
    organisationAction.verifyStorage(storageElement).then(
      data => {
        callback && callback();
      }
    ).catch (
      error => {
        callback && callback(error);
      }
    )
  }

  handleSaveOrgClick = (editCustomerData, callBack) => {
    this.setState({spinnerVisibilityMain:true})
    organisationAction
    .saveCustomerAction(editCustomerData, this.props.editOrganisationData.id)
    .then(
      response_data => {
        toastr.success(`${getMessage("ORGANIZATION_UPDATED_SUCCESSFULLY")}`);
        callBack("");      
        setTimeout(() => { 
          this.setState({ spinnerVisibilityMain: false });
          this.props.history.goBack();
        }, TIMEOUT.SHORT);
      },
      error => {
        this.setState({spinnerVisibilityMain:false})
        let errorMessage = error.code === ERROR.NETWORK_ERROR
          ? toastr.error(getMessage(error.code))
          : getMessage(error.code);
        callBack(errorMessage)
      }
      
    );
  };

  uploadImage = (formData, data) => {
    this.setState({ spinnerVisibilityMain: true });
    organisationAction.uploadOrgLogoStatusAction(formData).then(
      response_data => {
        this.setState(
          {
            spinnerVisibilityMain: false,
            isDataEdited: false
          }
        );
        data.logoUrl = response_data.data.data.logoUrl;
        this.handleSaveOrgClick(data, errorMessage => {
          this.setState({ errorMessage: errorMessage });
        });
      },
      error => {
        this.setState({ spinnerVisibilityMain: false });
        this.setState({ errorMessage: error.message });
      }
    );
  };

  uploadTenantWording = (formData, data, isImageChanged, isWordingChanged) => {
    this.setState({ spinnerVisibilityMain: true });
    organisationAction.uploadOrgTenantWordingStatusAction(formData).then(
      response_data => {
        data.wordingUrl = response_data.data.data.wordingUrl;
        if (!(isImageChanged && isWordingChanged)) {
          this.setState(
            {
              spinnerVisibilityMain: false,
              isDataEdited: false
            }
          );
          this.handleSaveOrgClick(data, errorMessage => {
            this.setState({ errorMessage: errorMessage });
          });
        }
      },
      error => {
        this.setState({ spinnerVisibilityMain: false });
        this.setState({ errorMessage: error.message });
        toastr.error(getMessage(error.code));
      }
    );
  };

  render() {
    return (
      <>
      {this.props.editOrganisationData ?
        <>
        <HeaderContainer
          title={getMessage("EDIT_ORGANIZATION")}
          showModal={false}
          history={this.props.history}
          handleSearchString={""}
          logo
          isDashboard={false}
        />
        <EditOrganization 
          handleSaveOrgClick={this.handleSaveOrgClick}
          language={this.props.language}
          verifyStorage={this.verifyStorage}
          uploadImage={this.uploadImage}
          uploadTenantWording={this.uploadTenantWording}
          editOrganisationData={this.props.editOrganisationData}
          handleCancelClick={this.handleCancelClick}
          sessionsCapacity={this.props.sessionsCapacity}
          wording={this.props.wording}
          translation={this.props.translation}
        />
        <Spinner showSpinner={this.state.spinnerVisibilityMain} />
        </>
        : null }
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    language: state.LanguageReducer.language,
    editOrganisationData:state.OrganisationReducer.Organization,
    sessionsCapacity:state.OrganisationReducer.sessionsCapacity,
    wording: getWording(state),
    translation: getTranslation(state)
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(EditOrganizationContainer));
